import { useState } from "react";
import { Form } from "react-bootstrap";

import styles from "./informationAboutExistingCertificate.module.css";

export default function InformationAboutExistingCertificate({
  mode,
  fieldsOptions,
  updateNewData,
  inputData,
}) {
  const handleChange = (e) => {
    if (e) {
      if (e.target) {
        updateNewData(e.target.id, e.target.value);
      } else {
        updateNewData(e.key, e.value);
      }
    }
  };
  return (
    <>
      {!!inputData["licenseNumExist"] && (
        <div className={styles["container-information"]}>
          <p className={styles["description-text"]}>
            Сведения о наличии удостоверения на право управления моторным маломерным судном, мощность
            двигателя которого превышает 3,7 киловатта (5 лошадиных сил) (при его наличии)
          </p>
          <div className={styles["inputs-container"]}>
            <div className={`${mode !== "view" && styles["information-about-existing-certificate"]}`}>
              {Object.values(fieldsOptions).map((item) => {
                if (mode === "add" || mode === "edit") {
                  return (
                    <Form.Group
                      controlId={`${item.key}`}
                      className={`${styles["common"]} ${styles[`box-${item.key}`]}`}>
                      <Form.Label>
                        {item.value}
                        {item.required && mode !== "view" && <span className={styles["red-dot"]}>*</span>}
                      </Form.Label>
                      <Form.Control
                        onChange={(e) => handleChange(e)}
                        type={item.type}
                        value={inputData[item.key]}
                        readOnly={item.readOnly || mode === "view"}
                        disabled={mode === "view" ? true : false}
                        // isInvalid={
                        //   (mode !== "view" && !!errors[item.key]) ||
                        //   (!!option.maxlength && newData[item.key]
                        //     ? newData[item.key].length > item.maxlength
                        //     : false)
                        // }
                      />
                    </Form.Group>
                  );
                } else {
                  return (
                    <div className={`${styles["text-block"]} ${styles[`box-${item.key}`]}`}>
                      <p className={styles["option-label"]}>{item.value}</p>
                      <p className={styles["option-value"]}>
                        {item.type === "selectSearch"
                          ? item.options.find((elem) => elem.value === inputData?.[item.key])?.label || "—"
                          : item.type === "date" && inputData?.[item.key]
                          ? inputData?.[item.key].split("-").reverse().join(".")
                          : inputData?.[item.key] || "—"}
                      </p>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
